import { chartThemeValidator } from "../../../util/colorPicker/chartThemeValidator";

function getDefaultColorStrategy(data, themeColors, colorPayload) {
  const newColors = [];
  for (let i = 0; i < data.length; i++) {
    const legendaIterada = typeof data[i] === "string" ? data[i] : data[i].name;
    const corAtualDaLegenda = colorPayload[legendaIterada];
    const corDaLegendaCorrespondenteDoTemaGeral = themeColors[i];

    newColors[i] = corAtualDaLegenda || corDaLegendaCorrespondenteDoTemaGeral;
  }

  return newColors;
}

function getWithInheritanceColorStrategy(
  data,
  themeColors,
  colorPayload,
  correspondingResultadosGeraisData
) {
  const newColors = [];

  for (let i = 0; i < data.length; i++) {
    const legendaIterada = typeof data[i] === "string" ? data[i] : data[i].name;
    const corAtualDaLegendaIterada = colorPayload[legendaIterada];

    /**
     * Indice da legenda do gráfico simples correspondente À legenda do gráfico
     * evolutivo, por exemplo, se as alternativas do grafico simples são
     * 
     * [A, B]
     * 
     * e do gráfico evolutivo são
     * 
     * [B, A, C]
     * 
     * então o output para legendaIterada = B tem que ser 1
     */
    const indiceLegendaCorrespondenteHerdada =
      correspondingResultadosGeraisData.legendas.findIndex(
        (legenda) => legenda.name === legendaIterada
      );

    const corCorrespondenteHerdada =
      correspondingResultadosGeraisData.colors[legendaIterada]
      || themeColors[indiceLegendaCorrespondenteHerdada];

    const legendaCorrespondenteDoTemaGeral = themeColors[i];

    newColors[i] =
      corAtualDaLegendaIterada ||
      corCorrespondenteHerdada ||
      legendaCorrespondenteDoTemaGeral;
  }

  return newColors;
}

// eslint-disable-next-line func-names
export const calculateReportChartColors = function ({
  data,
  theme,
  chartsColors,
  simpleChartInheritanceConfig,
}) {
  if (!data) {
    return theme.colors.charts.colors;
  }

  // Faz uma cópia temporária do objeto de configurações
  // Esse objeto vem do payload de configurações dos gráficos, é o objeto que armazena as cores salvas.
  const chartColorObj = { ...chartsColors };
  const themeColors = chartThemeValidator(
    theme.colors.charts.colors,
    data.length
  );

  if (simpleChartInheritanceConfig) {
    return getWithInheritanceColorStrategy(
      data,
      themeColors,
      chartColorObj,
      simpleChartInheritanceConfig
    );
  }

  return getDefaultColorStrategy(data, themeColors, chartColorObj);
};
